import { useState, useEffect } from 'react';

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

/**
 * Custom hook to detect if the current viewport matches a breakpoint.
 *
 * @param {string} breakpoint - The breakpoint key (sm, md, lg, xl, 2xl)
 * @returns {boolean} - True if the viewport is at least the breakpoint width
 */
export const useBreakpoint = (breakpoint = 'md') => {
  const [isMatch, setIsMatch] = useState(false);

  useEffect(() => {
    const width = breakpoints[breakpoint] || breakpoints.md;
    const mediaQuery = window.matchMedia(`(min-width: ${width}px)`);

    const handleChange = () => {
      setIsMatch(mediaQuery.matches);
    };

    handleChange();

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [breakpoint]);

  return isMatch;
};
